/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ContextualHelpIcon = /*#__PURE__*/ createSvgIcon(
  'ContextualHelpIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.996 14c.21 0 .39-.072.535-.216a.72.72 0 00.219-.534v-3.5a.728.728 0 00-.214-.534.72.72 0 00-.532-.216.734.734 0 00-.535.216.72.72 0 00-.219.534v3.5c0 .213.071.39.214.534a.72.72 0 00.532.216zm0-6.5c.21 0 .39-.071.535-.214a.714.714 0 00.219-.532.736.736 0 00-.214-.535.714.714 0 00-.532-.219.736.736 0 00-.535.214.714.714 0 00-.219.532c0 .21.071.39.214.535.143.146.32.219.532.219zm.01 10.5a7.81 7.81 0 01-3.11-.625 8.064 8.064 0 01-2.552-1.719 8.065 8.065 0 01-1.719-2.551A7.819 7.819 0 012 9.99c0-1.104.208-2.14.625-3.105a8.066 8.066 0 014.27-4.26A7.819 7.819 0 0110.01 2a7.75 7.75 0 013.105.625 8.082 8.082 0 014.26 4.265A7.77 7.77 0 0118 9.994a7.81 7.81 0 01-.625 3.11 8.063 8.063 0 01-1.719 2.552 8.081 8.081 0 01-2.546 1.719 7.77 7.77 0 01-3.104.625zM10 16.5c1.806 0 3.34-.632 4.604-1.896C15.868 13.34 16.5 11.806 16.5 10s-.632-3.34-1.896-4.604C13.34 4.132 11.806 3.5 10 3.5s-3.34.632-4.604 1.896C4.132 6.66 3.5 8.194 3.5 10s.632 3.34 1.896 4.604C6.66 15.868 8.194 16.5 10 16.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ContextualHelpIcon;
